export default __webpack_public_path__ + "static/media/storeImg.9b074b90.PNG";